import {
  GET_USERDETAILS,
  GET_USERDETAILS_SUCCESSED,
  GET_USERDETAILS_FAILED,
} from '../actions/actionTypes'

const initialState = {
  data: { roles: [] },

  requesting_get: false,
  requesting_get_successful: false,
  message: null,
  loading_message: "Loading user details..."
}

function userReducers(state = initialState, action) {
  switch (action.type) {
    case GET_USERDETAILS:
      return Object.assign({}, {
        requesting_get: true,
        requesting_get_successful: false,
        data: Object.assign({}, state.data),
        message: null,
        loading_message: "Loading user details..."
      })
    case GET_USERDETAILS_SUCCESSED:
      return Object.assign({}, {
        requesting_get: false,
        requesting_get_successful: true,
        data: Object.assign({}, action.data),
        message: null,
        loading_message: state.loading_message
      })
    case GET_USERDETAILS_FAILED:
      return Object.assign({}, {
        requesting_get: false,
        requesting_get_successful: false,
        data: Object.assign({}, { "roles": [] }),
        message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
        loading_message: state.loading_message
      })

    default:
      return state
  }
}

export default userReducers;
